<template>
    <div id="basicModal" class="js-modal-window u-modal-window" style="width: 500px;">
        <div class="card">
            <!-- Header -->
            <header class="card-header bg-light py-3 px-5">
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="h6 mb-0"> {{ title }}</h3>

                    <button type="button" class="close" aria-label="Close" @click="close_and_redirect">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </header>
            <!-- End Header -->

            <!-- Body -->
            <div class="card-body p-5">
                <p>{{ text }}</p>
            </div>
            <!-- End Body -->

            <!-- Footer -->
            <div class="card-footer d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-primary transition-3d-hover mr-1"
                        @click="close_and_redirect">
                    Okay
                </button>
            </div>
            <!-- End Footer -->

            <a ref="closer" hidden onclick="Custombox.modal.close();">Close modal</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BasicModal",
        props: ["title", "text", "next"],
        methods: {
            close_and_redirect: function (event) {
                event.preventDefault();
                this.$refs.closer.click();
                this.$router.push({'name': this.next});
            }
        }
    }
</script>

<style scoped>

</style>